/** Mirror of backend seo.SlugifyName / PlayerPathSlug for stable SEO URLs. */

function slugifyName(name: string): string {
  const lower = (name || "").trim().toLowerCase();
  if (!lower) return "";
  let out = "";
  let lastDash = false;
  for (const ch of lower) {
    if (/[\p{L}\p{N}]/u.test(ch)) {
      out += ch;
      lastDash = false;
      continue;
    }
    if (!lastDash && out.length > 0) {
      out += "-";
      lastDash = true;
    }
  }
  return out.replace(/^-+|-+$/g, "");
}

function externalIDSuffix(externalID: string): string {
  let s = (externalID || "").trim().toLowerCase();
  if (s.startsWith("name-")) s = s.slice(5);
  s = s.replace(/-/g, "");
  if (!s) return "";
  if (/^\d+$/.test(s)) return s;
  return s.length > 12 ? s.slice(0, 12) : s;
}

export function playerPathSlug(player: {
  fullname?: string | null;
  englishName?: string | null;
  externalId?: string | null;
  slug?: string | null;
}): string {
  const ext = (player.externalId || "").trim();
  let base = slugifyName(player.englishName || "");
  if (!base) base = slugifyName(player.fullname || "");
  if (!base) base = "player";
  if ([...base].length > 60) {
    base = [...base].slice(0, 60).join("").replace(/^-+|-+$/g, "");
  }
  const suffix = externalIDSuffix(ext);
  if (!suffix) {
    const existing = (player.slug || "").trim();
    return existing || base;
  }
  return `${base}-${suffix}`;
}

/** Public SPA path for a transfer player profile (SEO slug preferred). */
export function transferPlayerPath(player: {
  slug?: string | null;
  externalId?: string | null;
  fullname?: string | null;
  englishName?: string | null;
}): string {
  const pretty = playerPathSlug(player);
  const id = pretty || (player.externalId || "").trim() || (player.slug || "").trim();
  return `/transfers/player/${id}`;
}

export function transferTeamPath(team: {
  slug?: string | null;
  externalId?: string | null;
}): string {
  const id = (team.slug || team.externalId || "").trim();
  return `/transfers/team/${id}`;
}
